import { render, staticRenderFns } from "./CustomerInfoTable.vue?vue&type=template&id=1cb6e9ac&scoped=true"
import script from "./CustomerInfoTable.vue?vue&type=script&lang=js"
export * from "./CustomerInfoTable.vue?vue&type=script&lang=js"
import style0 from "./CustomerInfoTable.vue?vue&type=style&index=0&id=1cb6e9ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cb6e9ac",
  null
  
)

export default component.exports